export const AUTH_TOKEN = "authToken";
export const USER = "user";
export const ADMIN = "admin";
//For Origin from JAKARTA PUSAT
export const ORIGIN = 151;
